"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MSSQLQueryPropertiesFactoryFromJS = exports.MSSQLQueryPropertiesFactory = void 0;
const immutable_1 = require("immutable");
const IDatabaseProperties_1 = require("../bases/IDatabaseProperties");
exports.MSSQLQueryPropertiesFactory = (0, immutable_1.Record)(Object.assign(Object.assign({}, IDatabaseProperties_1.DatabasePropertiesRecord), { commandType: 1 /* EMSSQLCommandTypes.TSQL */, executionType: null }));
const MSSQLQueryPropertiesFactoryFromJS = function (data) {
    return (0, exports.MSSQLQueryPropertiesFactory)(Object.assign(Object.assign({}, (0, IDatabaseProperties_1.DatabasePropertiesFactoryObjectFromJS)(data)), { executionType: data.executionType, commandType: data.commandType }));
};
exports.MSSQLQueryPropertiesFactoryFromJS = MSSQLQueryPropertiesFactoryFromJS;
//# sourceMappingURL=IMSSQL.js.map